<prlw-mobile-overlay-card-ui
  *ngIf="xsmall$ | async; else common"
  label="Оставить заявку на&nbsp;покупку"
  (eventClickX)="closeOverlay.emit()"
>
  <ng-container body *ngIf="isInit(status)">
    <div *ngIf="instrument" class="text-description-section-mobile">
      <div>
        <div>Наименование базиса:</div>
        <div class="data">
          {{ instrument.shipment.code
          }}<prlw-text-tag-otp
            [instrumentCode]="instrument.instrumentCode"
            size="medium"
          ></prlw-text-tag-otp>
        </div>
      </div>
      <div>
        <div>Наименование продукта:</div>
        <div class="data">{{ instrument.instrumentName }}</div>
      </div>
      <div>
        <div>Цена на станции назначения:</div>
        <div class="data">{{ instrument.totalPrice | delimitNumber }} ₽</div>
      </div>
      <div>
        <div>Время в пути:</div>
        <div class="data">{{ instrument.shipmentDays || '-' }}</div>
      </div>
    </div>
    <div class="gradient"></div>
    <div class="inputs-section-mobile">
      <div class="label-input-mobile" prlwResponsive>
        <div>Станция</div>

        <button
          *ngIf="xsmall$ | async"
          class="station-button"
          (click)="eventOpenDestinationsOverlay.emit()"
        >
          {{ currentDestination?.name }}
        </button>
        <svg
          (click)="eventOpenDestinationsOverlay.emit()"
          width="16"
          height="15"
          viewBox="0 0 16 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.1291 9.37931H10.4707L10.2374 9.15431C11.0541 8.20431 11.5457 6.97098 11.5457 5.62931C11.5457 2.63765 9.12074 0.212646 6.12907 0.212646C3.1374 0.212646 0.712402 2.63765 0.712402 5.62931C0.712402 8.62098 3.1374 11.046 6.12907 11.046C7.47074 11.046 8.70407 10.5543 9.65407 9.73765L9.87907 9.97098V10.6293L14.0457 14.7876L15.2874 13.546L11.1291 9.37931ZM6.12907 9.37931C4.05407 9.37931 2.37907 7.70431 2.37907 5.62931C2.37907 3.55431 4.05407 1.87931 6.12907 1.87931C8.20407 1.87931 9.87907 3.55431 9.87907 5.62931C9.87907 7.70431 8.20407 9.37931 6.12907 9.37931Z"
            fill="#666666"
          />
        </svg>
        <input
          *ngIf="(xsmall$ | async) === false"
          [formControl]="station"
          class="input"
          data-cy="buy-product-station-search"
          placeholder="Выберите станцию"
          [class.empty]="!destinations?.length"
          prlwResponsive
        />
      </div>
      <ng-container *ngIf="station.value && !isStationSelected">
        <ng-container *ngIf="destinations?.length; else empty">
          <div class="list" prlwResponsive>
            <div
              class="list__item"
              data-cy="buy-product-destination"
              *ngFor="
                let destination of destinations | slice: 0 : 5;
                let i = index
              "
              (click)="setCurrent(destination.destination)"
            >
              {{ destination.destination.name }}
            </div>
          </div>
        </ng-container>
      </ng-container>

      <prlw-number-input-ui
        *ngIf="minAmount"
        appearance="grey"
        label="Объем (т)"
        [minValue]="minAmount"
        data-cy="buy-product-volume"
        (setValue)="setVolume($event)"
        [column]="false"
      ></prlw-number-input-ui>
    </div>

    <button
      class="buy-button-mobile"
      data-cy="make-buy-request"
      (click)="makeBuyRequest()"
      [disabled]="disabledBtn"
    >
      <div>Оставить заявку.</div>
      <div class="bold">Итого:</div>
      <div [class.total-price-color]="totalPriceIsNotAsterisks" class="bold">
        {{
          this.volume.valid && calculateTotalPrice
            ? (calculateTotalPrice | delimitNumber)
            : '-'
        }}
        ₽
      </div>
    </button>
  </ng-container>

  <ng-container body *ngIf="isSending(status)">
    <div class="plug-container" data-cy="buy-product-loader" prlwResponsive>
      <div class="loader loader--a"></div>
      <div class="loader loader--b"></div>
      <div class="loader loader--c"></div>
    </div>
  </ng-container>

  <ng-container body *ngIf="isSent(status)">
    <div class="plug-container" data-cy="buy-product-success">
      <span class="plug-container__text">Ваша заявка отправлена!</span>
    </div>
  </ng-container>

  <ng-container body *ngIf="isError(status)">
    <div class="plug-container" data-cy="buy-product-error">
      <span class="plug-container__text">При отправке произошла ошибка</span>
      <button
        class="buy-button-mobile repeat"
        (click)="repeat()"
        prlwResponsive
      >
        Повторить
      </button>
    </div>
  </ng-container>
</prlw-mobile-overlay-card-ui>

<ng-template #common>
  <div class="container">
    <div class="header">
      <span class="header__title">Оставить заявку на покупку</span>
      <prlw-icon
        name="close-cross"
        data-cy="buy-product-modal-close"
        class="close-btn"
        (click)="close()"
      ></prlw-icon>
    </div>

    <ng-container *ngIf="isInit(status)">
      <div *ngIf="instrument" class="details" data-cy="buy-product-details">
        <div>
          <div>Наименование базиса:</div>
          <div class="data">
            {{ instrument.shipment.code
            }}<prlw-text-tag-otp
              [instrumentCode]="instrument.instrumentCode"
              size="medium"
            ></prlw-text-tag-otp>
          </div>
        </div>
        <div>
          <div>Цена на станции назначения:</div>
          <div class="data">{{ instrument.totalPrice | delimitNumber }} ₽</div>
        </div>
        <div>
          <div>Итоговая сумма:</div>
          <div
            [class.total-price-color]="totalPriceIsNotAsterisks"
            class="data"
          >
            {{
              this.volume.valid && calculateTotalPrice
                ? (calculateTotalPrice | delimitNumber)
                : '-'
            }}
            ₽
          </div>
        </div>
        <div>
          <div>Наименование продукта:</div>
          <div class="data">{{ instrument.instrumentName }}</div>
        </div>
        <div>
          <div>Время в пути:</div>
          <div class="data">{{ instrument.shipmentDays || '-' }}</div>
        </div>
        <div>
          <div></div>
          <div class="data"></div>
        </div>
        <div>
          <div>Станция назначения:</div>
          <input
            [formControl]="station"
            class="input"
            data-cy="buy-product-station-search"
            placeholder="Выберите станцию"
            [class.empty]="!destinations?.length"
          />
          <ng-container *ngIf="station.value && !isStationSelected">
            <ng-container *ngIf="destinations?.length; else empty">
              <div class="list">
                <div
                  class="list__item"
                  data-cy="buy-product-destination"
                  *ngFor="
                    let destination of destinations | slice: 0 : 5;
                    let i = index
                  "
                  (click)="setCurrent(destination.destination)"
                >
                  {{ destination.destination.name }}
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <prlw-number-input-ui
          *ngIf="minAmount"
          label="Объем (тонн):"
          [minValue]="minAmount"
          data-cy="buy-product-volume"
          (setValue)="setVolume($event)"
        ></prlw-number-input-ui>
      </div>
      <button
        class="buy-button"
        data-cy="make-buy-request"
        (click)="makeBuyRequest()"
        [disabled]="disabledBtn"
      >
        Оставить заявку
      </button>
    </ng-container>

    <ng-container *ngIf="isSending(status)">
      <div class="plug-container" data-cy="buy-product-loader">
        <div class="loader loader--a"></div>
        <div class="loader loader--b"></div>
        <div class="loader loader--c"></div>
      </div>
    </ng-container>

    <ng-container *ngIf="isSent(status)">
      <div class="plug-container" data-cy="buy-product-success">
        <span class="plug-container__text">Ваша заявка отправлена!</span>
      </div>
    </ng-container>

    <ng-container *ngIf="isError(status)">
      <div class="plug-container" data-cy="buy-product-error">
        <span class="plug-container__text">При отправке произошла ошибка</span>
        <button class="buy-button" (click)="repeat()">Повторить</button>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #empty>
  <div class="list error" data-cy="buy-product-destination-stub">
    К сожалению, по вашему запросу ничего не найдено
  </div>
</ng-template>
